import { RefObject } from 'react';

import { TypographyGrey } from '/styles/shared/styledText';

import { MAX_TEXT_WIDTH } from './constant';

interface HiddenTextProps {
  initialTextRef: RefObject<HTMLElement>;
  copiedTextRef: RefObject<HTMLElement>;
  initialText: string;
  copiedText: string;
}

export const HiddenText = ({ initialTextRef, copiedTextRef, initialText, copiedText }: HiddenTextProps) => {
  return (
    <div style={{ position: 'absolute', opacity: 0, zIndex: -1, pointerEvents: 'none' }}>
      <TypographyGrey
        variant='body2'
        ref={initialTextRef}
        fontWeight={500}
        maxWidth={MAX_TEXT_WIDTH}
        sx={{
          wordBreak: 'break-all',
        }}
      >
        {initialText}
      </TypographyGrey>
      <TypographyGrey
        variant='body2'
        ref={copiedTextRef}
        fontWeight={500}
        maxWidth={MAX_TEXT_WIDTH}
        sx={{
          wordBreak: 'break-all',
        }}
      >
        {copiedText}
      </TypographyGrey>
    </div>
  );
};
